// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f768f10c","750":"bf64fc8f"}[chunkId] + ".chunk.js";
};